





























































































































































import {
  apiOrderWriteOffUserStoreList,
  ApiOrderWriteOffUserStoreListResponse,
  apiOrderWriteOffWriteOffDetail,
  apiOrderWriteOffWriteOffList,
} from '@/api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi } from '@/hooks'
import { formatDate, subYears } from 'vtils/date'
import { navigateTo } from '@/router'
import { nextTick, ref } from '@vue/composition-api'
import { RequiredDeep } from 'vtils/types'
import { submit, Track } from '@/utils'
import { useWaterfall, XWaterfallLoad } from '@/components'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '管理端',
        }))
      }

      currentMart =
        ref<RequiredDeep<ApiOrderWriteOffUserStoreListResponse>[0]>()

      martApiData = useApi(
        () =>
          apiOrderWriteOffUserStoreList().then(res => {
            this.currentMart.value =
              (res.find(item => !!item.defaultChoose) as any) ||
              (res[0] as any)
            return res
          }),
        {
          refreshOnActivated: true,
        },
      )

      showInputVerifyDialog = ref(false)

      inputVerifyCode = ref('')

      date = ref(new Date())

      minDate = ref(subYears(new Date(), 1))

      maxDate = ref(new Date())

      keyword = ref('')

      isFold = ref(true)

      waterfall = useWaterfall('list', {
        reloadWatcher: () => [this.date.value, this.currentMart.value],
      })

      // 扫码核销
      handleScanVerifyClick = async () => {
        const res = await dcb.scanCode({
          returnResult: true,
        })
        dcb.navigateTo({
          url: res.result!,
        })
      }

      // 券码核销
      handleInputVerifyClick = () => {
        this.showInputVerifyDialog.value = true
      }

      // 券码核销-取消
      handleInputVerifyCancelClick = () => {
        this.showInputVerifyDialog.value = false
      }

      // 券码核销-确认
      handleInputVerifyConfirmClick = () => {
        submit(async $ => {
          if (!this.inputVerifyCode.value) {
            return $.fail('请输入券码')
          }
          $.start()
          await apiOrderWriteOffWriteOffDetail({
            code: this.inputVerifyCode.value,
          })
          this.showInputVerifyDialog.value = false
          nextTick(() => {
            navigateTo('BookVerifyConfirm', {
              code: this.inputVerifyCode.value,
            })
            this.inputVerifyCode.value = ''
          })
        })
      }

      // 搜索
      handleSearch = () => {
        this.waterfall.reload()
      }

      // 加载数据
      handleLoadData: XWaterfallLoad = ({ pageNumber }) => {
        return pageNumber === 1
          ? apiOrderWriteOffWriteOffList({
              merchantId: this.currentMart.value!.merchantId,
              writeOffDate: formatDate(this.date.value, 'yyyy-mm-dd'),
              code: this.keyword.value,
            })
          : []
      }

      // 券码
      handleCodeClick = (code: string) => {
        navigateTo('BookVerifyDetail', {
          code: code,
        })
      }

      // 收起-展开
      handleFoldClick = () => {
        this.isFold.value = !this.isFold.value
      }

      // 切换店铺
      handleChangeStoreClick = () => {
        navigateTo('BookVerifyMart', {
          martId: this.currentMart.value!.merchantId,
        })
      }
    },
)
